/**
 * @vuelto-surface
 * mobile: ok
 * desktop: n/a
 * strategy: inherit
 */
import React, { useState } from 'react';
import { View } from 'react-native';
import { TicketListRow } from '../../../../shared/ticket/TicketListRow';
import { ModuleEmptyState } from '../../../../shared/ui/ModuleEmptyState';
import { getInitials } from '../../../teamUtils';
import type { EmployeeRecord } from '../../../store/useEmployeesStore';
import type { EmployeePermissionsVm } from './useEmployeePermissions';
import { summarizeEmployeeModuleAccess } from './permissionUiLabels';
import { EmployeeActiveCompactModules } from './EmployeeActiveCompactModules';
import { invitationRoleLabel } from './EmployeeRolePresets';

type Props = {
  vm: EmployeePermissionsVm;
};

export function EmployeeActiveTab({ vm }: Props) {
  const { filteredActiveEmployees, onOpenDetail, visibleModules, branchFilter } = vm;
  const [expandedEmployeeId, setExpandedEmployeeId] = useState<string | null>(null);

  if (filteredActiveEmployees.length === 0) {
    return (
      <ModuleEmptyState
        title="Sin resultados"
        subtitle="No hay empleados activos con estos filtros."
        testID="perfil.team.permissions.no-results"
      />
    );
  }

  return (
    <View>
      {filteredActiveEmployees.map((employee: EmployeeRecord) => {
        const assignmentCount = employee.branchAssignments.length;
        const assignmentCountLabel =
          assignmentCount === 1 ? '1 sucursal' : `${assignmentCount} sucursales`;
        const moduleSummary = summarizeEmployeeModuleAccess(
          employee,
          visibleModules,
          branchFilter
        );
        const subtitleParts = [invitationRoleLabel(employee.role), moduleSummary, assignmentCountLabel].filter(Boolean);
        const expanded = expandedEmployeeId === employee.id;

        return (
          <TicketListRow
            key={employee.id}
            title={employee.name}
            subtitle={subtitleParts.join(' · ')}
            meta={employee.email ?? null}
            avatar={{ initials: getInitials(employee.name), tone: 'gold' }}
            showChevron
            onPress={() =>
              setExpandedEmployeeId((current) => (current === employee.id ? null : employee.id))
            }
            accessibilityLabel={`${employee.name}. ${expanded ? 'Contraer' : 'Expandir'} permisos por módulo`}
            testID="perfil.team.permissions.employee-row"
            footer={
              expanded ? (
                <EmployeeActiveCompactModules
                  employee={employee}
                  visibleModules={visibleModules}
                  branchFilter={branchFilter}
                  onEdit={() => onOpenDetail(employee.id)}
                />
              ) : null
            }
          />
        );
      })}
    </View>
  );
}
